import {
  DEFAULT_AMOUNT_SAMPLE,
  DEFAULT_CRITERION,
  DEFAULT_LABORATORY,
  DEFAULT_VALID_PREPARATION,
  TYPE_ANALYSIS_ALFATOTAL_OPTIONS,
} from "@app/pages/samples/utils/constants";
import { useSample } from "@app/pages/samples/utils/useSample";
import { formatDateOrNow } from "@app/utils/formatDate";
import dayjs from "dayjs";

export const getCommonDefaultValues = (defaultPreloadValues) => {
  const {
    user,
    sampling,
    filteredProceduresPRE,
    filteredProceduresCON,
    filteredCalculationCAL,
    currentCounting,
    currentCalculation,
    consultEquipment,
    currentPreparationIndex,
    processingDateTimeEnd,
    idMuestra,
  } = defaultPreloadValues;

  const currentCountingIndex =
    currentPreparationIndex?.countings?.[currentCounting?.index as number];
  const currentCalculationIndex =
    currentCountingIndex?.calculations[currentCalculation?.index as number];
  const currentSampling = sampling?.current;

  const defaultTypeUnit = sampling?.current?.unit_types;
  const currentSample = useSample.getState().get(Number(idMuestra));

  return {
    //preparation
    typePreparation: currentPreparationIndex?.type
      ? TYPE_ANALYSIS_ALFATOTAL_OPTIONS.find(
          (option) => option.id === Number(currentPreparationIndex?.type)
        )
      : undefined,
    proccesing_date: dayjs(processingDateTimeEnd).format("YYYY-MM-DD"),
    analysis_analyst: currentPreparationIndex?.analyst,
    preparation_procedure:
      currentPreparationIndex?.preparation_procedure || filteredProceduresPRE,
    start_date: formatDateOrNow(currentPreparationIndex?.start_date),
    analysis_amount_sample: currentPreparationIndex?.amount_sample || 0,
    analysis_equipment: currentPreparationIndex?.equipment || [],
    valid_preparation:
      currentPreparationIndex?.valid_preparation || DEFAULT_VALID_PREPARATION,
    analysis_unit_types: currentPreparationIndex?.unit_types || defaultTypeUnit,

    // Counting
    counting_analyst: currentCountingIndex?.analyst || user,
    counting_procedure:
      currentCountingIndex?.counting_procedure || filteredProceduresCON,
    counting_equipment: currentCountingIndex?.equipo || undefined,
    counting_date: formatDateOrNow(currentCountingIndex?.counting_date),
    applied_criterion:
      currentCountingIndex?.applied_criterion || DEFAULT_CRITERION,
    sqp_tsie_white: currentCountingIndex?.sqp_tsie_white || "",
    sqp_tsie_sample: currentCountingIndex?.sqp_tsie_sample || "",
    variation_sqp_tsie: currentCountingIndex?.variation_sqp_tsie || "",
    counting_valid: currentCountingIndex?.counting_valid || "",
    sample_cpm: currentCountingIndex?.sample_cpm || "",
    gross_white_cpm: currentCountingIndex?.gross_white_cpm || "",
    total_sample_counting_time:
      currentCountingIndex?.total_sample_counting_time || "",
    total_white_counting_time:
      currentCountingIndex?.total_white_counting_time || "",
    counting_detector: currentCountingIndex?.detectors || undefined,

    // Calculation
    laboratory: currentCalculationIndex?.laboratory || DEFAULT_LABORATORY,
    calculation_equipment: currentCalculationIndex?.equipment
      ? Array.isArray(currentCalculationIndex?.equipment)
        ? currentCalculationIndex?.equipment
        : consultEquipment(Number(currentCalculationIndex?.equipment))
      : currentCountingIndex?.equipo && [currentCountingIndex?.equipo],
    calculation_analyst: currentCalculationIndex?.analyst || user,
    start_date_time: formatDateOrNow(currentSampling?.date_start_sampling),
    end_date_time: formatDateOrNow(currentSampling?.date_end_sampling),
    calculation_amount_sample:
      currentPreparationIndex?.amount_sample || undefined,
    calculation_units: currentPreparationIndex?.unit_types || undefined,
    calculation_tsie_white: currentCountingIndex?.sqp_tsie_white || undefined,
    calculation_tsie_sample: currentCountingIndex?.sqp_tsie_sample || undefined,
    calculation_shared: currentSample?.shared ? "Si" : "No",
    calculation_counting_date: currentCountingIndex?.counting_date || undefined,
    sample_gross_cpm: currentCountingIndex?.sample_cpm || undefined,
    gross_target_cpm: currentCountingIndex?.gross_white_cpm || undefined,
    total_time_counting:
      currentCountingIndex?.total_sample_counting_time || undefined,
    calculation: currentCalculationIndex?.calculation || "",
    calculation_procedure:
      currentCalculationIndex?.calculation_procedure || filteredCalculationCAL,
    sampledAirVolumeSilicagel:
      currentPreparationIndex?.sampledAirVolumeSilicagel || "",
    calculation_date: formatDateOrNow(
      currentCalculationIndex?.calculation_date
    ),
    idResultPreload: currentCalculationIndex?.result?.id || undefined,
  };
};
